var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitorGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6333 14.975H5.36663C2.04996 14.975 1.04163 13.9666 1.04163 10.65V5.36663C1.04163 2.04996 2.04996 1.04163 5.36663 1.04163H14.625C17.9416 1.04163 18.95 2.04996 18.95 5.36663V10.6416C18.9583 13.9666 17.95 14.975 14.6333 14.975ZM5.36663 2.29163C2.74996 2.29163 2.29163 2.74996 2.29163 5.36663V10.6416C2.29163 13.2583 2.74996 13.7166 5.36663 13.7166H14.625C17.2416 13.7166 17.7 13.2583 17.7 10.6416V5.36663C17.7 2.74996 17.2416 2.29163 14.625 2.29163H5.36663V2.29163Z",
    fill: "#61BD85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.9583C9.65833 18.9583 9.375 18.675 9.375 18.3333V14.35C9.375 14.0083 9.65833 13.725 10 13.725C10.3417 13.725 10.625 14.0083 10.625 14.35V18.3333C10.625 18.675 10.3417 18.9583 10 18.9583Z",
    fill: "#61BD85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 11.4584H1.66663C1.32496 11.4584 1.04163 11.175 1.04163 10.8334C1.04163 10.4917 1.32496 10.2084 1.66663 10.2084H18.3333C18.675 10.2084 18.9583 10.4917 18.9583 10.8334C18.9583 11.175 18.675 11.4584 18.3333 11.4584Z",
    fill: "#61BD85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 18.9584H6.25C5.90833 18.9584 5.625 18.675 5.625 18.3334C5.625 17.9917 5.90833 17.7084 6.25 17.7084H13.75C14.0917 17.7084 14.375 17.9917 14.375 18.3334C14.375 18.675 14.0917 18.9584 13.75 18.9584Z",
    fill: "#61BD85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorGreen);
export default __webpack_public_path__ + "static/media/monitor_green.7e69465da67f70509524415b79f82480.svg";
export { ForwardRef as ReactComponent };